
$(document).ready(function(){

  jQuery('ul#SiteNav li a').eq(0).click(function(e) {
location.replace("https://neuapplianceoutlet.com/collections/all-appliances");
});
  
 load_badges(); 
   jQuery('.usf-btn').click(function() {
      load_badges();
   });
   jQuery(window).scroll(function() {
      load_badges();
   });
   function load_badges() {

      jQuery('.products .product').each( function() {
         if(!jQuery(this).find('.bss_pl_img').length){
            if(jQuery(this).find('.prod-card-meta-info').find('p:contains("Open Box")').text()){
               jQuery(this).find('.product-card-image').append('<div class="bss_pl_img " style="display: block !important;"> <img bss-config-id="115668" src="https://cdn.shopify.com/s/files/1/0580/4523/5373/files/1713017572992-597786790-Frame70702.png?v=1713017583" loading="lazy" alt="Open Box" class="bss-pl-frontend bss_pl_text_hover_link_disable" style=" position: absolute !important; background-color: transparent; display: block; min-height: auto !important; transform: rotate(0deg); transform-origin: center; animation-duration: 2s; animation-iteration-count: infinite; opacity: 1; z-index:4; top: 1.952%!important; right: 3.232999999999997%!important; width:35% !important;height:auto !important;"></div>');
            }
            if(jQuery(this).find('.prod-card-meta-info').find('p:contains("Scratch & Dent")').text()){
               jQuery(this).find('.product-card-image').append('<div class="bss_pl_img " style="display: block !important;"> <img bss-config-id="115669" src="https://cdn.shopify.com/s/files/1/0580/4523/5373/files/1713017617236-641000573-Frame7070.png?v=1713017661" loading="lazy" alt="Untitled label" class="bss-pl-frontend   bss_pl_text_hover_link_disable" style=" position: absolute !important; background-color: transparent; display: block; min-height: auto !important; transform: rotate(0deg); transform-origin: center; animation-duration: 2s; animation-iteration-count: infinite; opacity: 1; z-index:4; top: 1.194%!important; right: 1.1739999999999995%!important; width:40% !important;height:auto !important;"></div>');
            }
            if(jQuery(this).find('.prod-card-meta-info').find('p:contains("Scratch and Dent")').text()){
               jQuery(this).find('.product-card-image').append('<div class="bss_pl_img " style="display: block !important;"> <img bss-config-id="115669" src="https://cdn.shopify.com/s/files/1/0580/4523/5373/files/1713017617236-641000573-Frame7070.png?v=1713017661" loading="lazy" alt="Untitled label" class="bss-pl-frontend   bss_pl_text_hover_link_disable" style=" position: absolute !important; background-color: transparent; display: block; min-height: auto !important; transform: rotate(0deg); transform-origin: center; animation-duration: 2s; animation-iteration-count: infinite; opacity: 1; z-index:4; top: 1.194%!important; right: 1.1739999999999995%!important; width:40% !important;height:auto !important;"></div>');
            }
            if(jQuery(this).find('.prod-card-meta-info').find('p:contains("Certified Refurbished")').text()){
               jQuery(this).find('.product-card-image').append('<div class="bss_pl_img " style="display: block !important;"><img bss-config-id="115649" src="https://cdn.shopify.com/s/files/1/0580/4523/5373/files/1712954192073-121169847-Frame70821.png?v=1712954226" loading="lazy" alt="Untitled label" class="bss-pl-frontend   bss_pl_text_hover_link_disable" style=" position: absolute !important; background-color: transparent; display: block; min-height: auto !important; transform: rotate(0deg); transform-origin: center; animation-duration: 2s; animation-iteration-count: infinite; opacity: 1; z-index:4; top: 1.427%!important; right: 1.1629999999999967%!important; width:55% !important;height:auto !important;"></div>');
            }
           if(jQuery(this).find('.prod-card-meta-info').find('p:contains("Certified Reburbished")').text()){
               jQuery(this).find('.product-card-image').append('<div class="bss_pl_img " style="display: block !important;"><img bss-config-id="115649" src="https://cdn.shopify.com/s/files/1/0580/4523/5373/files/1712954192073-121169847-Frame70821.png?v=1712954226" loading="lazy" alt="Untitled label" class="bss-pl-frontend   bss_pl_text_hover_link_disable" style=" position: absolute !important; background-color: transparent; display: block; min-height: auto !important; transform: rotate(0deg); transform-origin: center; animation-duration: 2s; animation-iteration-count: infinite; opacity: 1; z-index:4; top: 1.427%!important; right: 1.1629999999999967%!important; width:55% !important;height:auto !important;"></div>');
            }
         }
      });

   }

  
  // Product Thumnail Slick Slider on Desktop
  // $slick_slider = $('.thumbnails-part');
  // settings_slider = {
  //   dots: true,
  //   autoplay: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   mobileFirst:true,
  //   responsive: [
  //     {
  //       breakpoint: 720,
  //       settings: {
  //         arrows: true,
  //         slidesToShow: 4,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // }
  // slick_on_desktop( $slick_slider, settings_slider);
  // function slick_on_desktop(slider, settings){
  //   $(window).on('load resize', function() {
  //     /*
  //     if ($(window).width() < 721) {
  //       if (slider.hasClass('slick-initialized')) {
  //         slider.slick('unslick');
  //       }
  //       return
  //     }
  //     */
  //     if (!slider.hasClass('slick-initialized')) {
  //       return slider.slick(settings);
  //     }
  //   });
  // };

//   $("tr#CartItem-1 button.quantity__button[name='plus']").click(function () {
//     console.log("Plus Button Clicked", ($("input#Quantity-1").val()-1))
//     $("input#Quantity-1").attr('value', $("input#Quantity-1").val());
// // console.log($("tr#CartItem-1 span.price.price--end").html())
//     $("tr#CartItem-1 span.price.price--end").html($("tr#CartItem-1 span.price.price--end").html().trim()/($("input#Quantity-1").val()-1)*$("input#Quantity-1").val())
//   });


  // $(".productImg").insertAfter($("ul.slick-dots"));
  // console.log("Custom JS")
});